module.exports = __webpack_public_path__ + "static/img/Round-23-2013.c128d71.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Round-23-2013.jpg
// module id = f/Du
// module chunks = 0